import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';

const URL = SERVICES.LOGIN.PATH;

@Injectable({
  providedIn: 'root',
})
export class LoginService extends AbstractService<any> {
  constructor(
    http: HttpClient,
    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  public login(data: any): Observable<any> {
    const url = SERVICES.LOGIN.PATH;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  public logout(): Observable<any> {
    const url = SERVICES.LOGOUT.PATH;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: {}
    });
  }

}
